import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/shared/components/ui/tabs';
import { PolicyForm } from './PolicyForm';
import { TypesTable } from './TypesTable';
import { SeniorityMatrixEditor } from './SeniorityMatrixEditor';
import { HolidaysTable } from './HolidaysTable';

/**
 * "Configuración" tab content on `TimeOffPage` — Owner/Admin only (the tab
 * trigger itself is gated by the parent). No activation gate here: the page
 * already wraps everything in `TimeOffActivationGate`.
 */
export function TimeOffConfigTab() {
  const { t } = useTranslation('timeOff');

  return (
    <div className="space-y-4" data-testid="time-off-config-tab">
      <h2 className="text-lg font-semibold">{t('settings.sectionTitle')}</h2>

      <Tabs defaultValue="policy">
        <div className="flex justify-center">
          <TabsList>
            <TabsTrigger value="policy">{t('settings.tabs.policy')}</TabsTrigger>
            <TabsTrigger value="types">{t('settings.tabs.types')}</TabsTrigger>
            <TabsTrigger value="matrix">{t('settings.tabs.matrix')}</TabsTrigger>
            <TabsTrigger value="holidays">{t('settings.tabs.holidays')}</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="policy">
          <PolicyForm />
        </TabsContent>
        <TabsContent value="types">
          <TypesTable />
        </TabsContent>
        <TabsContent value="matrix">
          <SeniorityMatrixEditor />
        </TabsContent>
        <TabsContent value="holidays">
          <HolidaysTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
